import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PDFDocument from './Pdfform';
import { pdf } from '@react-pdf/renderer';
import { useEffect, useState } from 'react';
import printpdf from '../assets/Print.svg';
import CloseIcon from '@mui/icons-material/Close';
import api from '../api/api';
import dayjs from 'dayjs';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ToastMessage from '../utils/muitoast';
import history from '../assets/history.svg'

const ReportsFilters = ({ setIsLoading, filters,setui,ui,selectedSuggestions, data,reportTableData, activeFilter,selectedJobDetails, setActiveFilter, selectedCompanyName, startDate, endDate, selectedCompanyId }) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userDetails);
  const role = user?.user_roles?.role || null;
  const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const [pdfBlob, setPdfBlob] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [employeeName, setEmployeeName] = useState('');
  const [taskDescription, setTaskDescription] = useState('');
  const [formErrors, setFormErrors] = useState({});
  const [clients, setClients] = useState([]);
  const [filteredClients, setFilteredClients] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedClient, setSelectedClient] = useState(null);

const [employees, setEmployees] = useState([]);
const [filteredEmployees, setFilteredEmployees] = useState([]);
const [selectedEmployee, setSelectedEmployee] = useState(null);

 const [alertmessage, setAlertMessage] = useState('');
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('success');
    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpen(false);
    };
  // Validation function
  const validateForm = () => {
    const errors = {};
const isSelectedEmployeeValid =
  selectedEmployee &&
  typeof selectedEmployee === 'object' &&
  Object.keys(selectedEmployee).length > 0;

const isSearchTermValid = typeof searchTerm === 'string' && searchTerm.trim() !== '';

if (!isSelectedEmployeeValid && !isSearchTermValid) {
  errors.selectedEmployee = 'Employee selection is required';
}

     if (!taskDescription.trim()) errors.taskDescription = 'Task description is required';
    return errors;
  };

  const fetchClients = async () => {
    try {
      const response = await api.get('/v1/reports/get-clients', {
        params: { company_id: selectedCompanyId },
      });
      if (Array.isArray(response.data)) {
        setClients(response.data);
        setFilteredClients(response.data);
      } else {
        console.error('Unexpected response structure: Expected an array', response.data);
        setClients([]);
        setFilteredClients([]);
      }
    } catch (error) {
      console.error('Error fetching clients:', error);
      setClients([]);
      setFilteredClients([]);
    }
  };

  useEffect(() => {
    if (selectedCompanyId) {
      fetchClients();
    }
  }, [selectedCompanyId]);

  // Handle modal open
  const handleOpenModal = () => {

    setIsModalOpen(true);
  };

  // Handle modal close
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEmployeeName('');
    setTaskDescription('');
    setFormErrors({});
    setSearchTerm('');
    setSelectedClient(null);
    setFilteredClients(clients);
    setSelectedEmployee(null)
  };

  const fetchEmployees = async (employee) => {
  try {
    const response = await api.get('/v1/timesheets/get-employee', {
      params: {empid:employee, company_id: selectedCompanyId  },
    });
    if (Array.isArray(response.data)) {
      setEmployees(response.data);
      setFilteredEmployees(response.data);
    } else {
      console.error('Unexpected response structure: Expected an array', response.data);
      setEmployees([]);
      setFilteredEmployees([]);
    }
  } catch (error) {
    console.error('Error fetching employees:', error);
    setEmployees([]);
    setFilteredEmployees([]);
  }
};



  const handleSearch = (e) => {
  const value = e.target.value;
  fetchEmployees(value)
  setSearchTerm(value);
  setFormErrors((prevErrors) => {
    const { selectedClient, ...rest } = prevErrors;
    return rest;
  });

  if (value.trim() === '') {
    setFilteredEmployees(employees);
    setSelectedEmployee(null);
  } else {
    const filtered = employees.filter(
      (emp) =>
        emp.empid.toString().toLowerCase().includes(value.toLowerCase()) ||
        emp.firstname.toLowerCase().includes(value.toLowerCase())||
        emp.lastname.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredEmployees(filtered);
  }
};

const handleSelectEmployee = (emp) => {
  setSelectedEmployee(emp);
  setSearchTerm('');
  setFilteredEmployees([]);
};

const clearSelection = () => {
  setSelectedEmployee(null);
  setSearchTerm('');
  setFilteredEmployees(employees);
};



  const getWeekDays = (start, end) => {
    const days = [];
    let current = dayjs(start);
    const endDate = dayjs(end);
    while (current.isSameOrBefore(endDate)) {
      days.push(current.format('dddd'));
      current = current.add(1, 'day');
    }
    return days;
  };

  const handleConfirmPrint = async () => {
    // const errors = validateForm();
    // if (Object.keys(errors).length > 0) {
    //   setFormErrors(errors);
    //   return;
    // }

 const matchedClient = clients.find((client) => client.clientnum === selectedJobDetails[0]?.clientnum);
   if (!matchedClient) {
     setOpen(true)
               setAlertMessage('There is no client details associated with this job ID')
               setSeverity('warning')
              setTimeout(() => {
               setOpen(false)
              }, 2000);
    return;
  }


    try {
      setIsLoading(true)
console.log(reportTableData)
      const blob = await pdf(
        <PDFDocument
          data={reportTableData}
          startDate={startDate}
          endDate={endDate}
          activeFilter={activeFilter}
          daysOfWeek={getWeekDays(startDate, endDate)}
          selectedCompanyName={selectedCompanyName}
          employeeName={employeeName}
          taskDescription={taskDescription||'-'}
          selectedClient={matchedClient}
          selectedSuggestions={selectedSuggestions}
   selectedEmployee={selectedEmployee}

        />
      ).toBlob();
      setPdfBlob(blob);
        const formData = new FormData();
        const fullName =selectedEmployee
  // (!selectedEmployee || 
  //  selectedEmployee === '' || 
  //  (typeof selectedEmployee === 'object' && Object.keys(selectedEmployee).length === 0)
  // )
  //   ? searchTerm
  //   : `${selectedEmployee?.firstname || ''} ${selectedEmployee?.lastname || ''}`.trim();

formData.append('orderedby', fullName);

    formData.append('file', new File([blob], 'weekly.pdf', { type: 'application/pdf' }));
    formData.append('orderedby', fullName||'-');
    formData.append('start_date', startDate);
    formData.append('end_date', endDate);
    formData.append('task_description', taskDescription||'-');
formData.append('job_id', selectedSuggestions[0]?.job_num)
    formData.append('user_id', user?.id);
    formData.append('role', user?.user_roles?.role );
//    const pdfUrl = URL.createObjectURL(blob);
//       window.open(pdfUrl, '_blank');
// return
    const response = await api.post('/v1/reports/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'accept': 'application/json',
          
        }
      }
    );
  const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, '_blank');
      handleCloseModal();
    } catch (error) {
      console.error('Error generating PDF:', error);
    }finally{
      setIsLoading(false)
    }
  };

  return (
    <div className="flex flex-wrap items-center justify-between py-4 gap-4 relative">
      <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handleClose} />
      <div className="flex flex-wrap items-center gap-4">
        <div onClick={() => {
          if(ui===1){
            setui(0)
          }else{
             navigate('/dashboard')
          }
         }} className="p-2 bg-[#F3F4F6] rounded-md cursor-pointer">
          <FontAwesomeIcon icon={faArrowLeft} className="text-xl text-black" />
        </div>
        <div className="text-xl font-semibold font-Font1 mb-2">
          {ui===0?"Reports":"History"}
        </div>
      </div>
     {ui===1?<></>:<div className='flex items-center justify-center gap-4'>
      {/* {selectedSuggestions.length <= 1 && (
  <button
    onClick={handleOpenModal}
    className="text-md px-6 font-inter text-sm py-2 rounded-md transition-colors duration-200 bg-[#900] text-white"
  >
    Print
  </button>
)} */}
<button
  onClick={handleOpenModal}
  disabled={selectedSuggestions.length !== 1||ui===1}
  className={`text-md px-4 gap-2 flex font-inter text-sm py-2 rounded-md transition-colors duration-200 ${
    selectedSuggestions.length !==1 ||ui==1? 'bg-gray-400 text-gray-200 cursor-not-allowed' : 'bg-[#900] text-white'
  }`}
>
 <img src={printpdf} alt='&!'/> Print
</button>
<button
onClick={()=>setui(1)}
  className="text-md px-4 gap-2 flex font-inter text-sm py-2 rounded-md transition-colors duration-200 bg-[#900] text-white"
>
  <img src={history} alt="&!" /> History
</button>

      </div>}

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <div className="flex justify-end mb-2 w-full">
              <CloseIcon onClick={handleCloseModal} style={{ width: '20px' }} className="cursor-pointer" />
            </div>
     
             <label className="block text-sm font-semibold text-left font-inter mb-1">
              Ordered by:
              </label>
          <div className="mb-4 relative">
        <input
    type="text"
    placeholder="Enter name..."
    value={selectedEmployee}
    onChange={(e) => {
      setSelectedEmployee(e.target.value);
      // setFormErrors((prevErrors) => {
      //   const { selectedEmployee, ...rest } = prevErrors;
      //   return rest;
      // });
    }}
    className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#900]"
  />     
  {/* <input
    type="text"
    placeholder="Search employee ID..."
    value={searchTerm}
    onChange={handleSearch}
    className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#900]"
  /> */}
{/* {formErrors.selectedEmployee && (
  <p className="text-red-500 text-sm">{formErrors.selectedEmployee}</p>
)} */}
{/* 
  {searchTerm && filteredEmployees.length > 0 && (
    <ul className="absolute top-full left-0 right-0 bg-white border border-gray-300 max-h-40 overflow-y-auto z-50">
      {filteredEmployees.map((emp) => (
        <li
          key={emp.empid}
          onClick={() => handleSelectEmployee(emp)}
          className="px-3 font-inter text-sm text-left py-2 hover:bg-gray-100 cursor-pointer border-b last:border-b-0"
        >
          {emp.firstname}  {emp.lastname} ({emp.empid})
        </li>
      ))}
    </ul>
  )} */}
  {/* {selectedEmployee && (
    <div
      className="font-inter text-sm"
      style={{
        marginTop: '8px',
        padding: '8px',
        background: '#e0f7fa',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: '1px solid pink',
      }}
    >
      <span>
       {selectedEmployee.firstname}  {selectedEmployee.lastname} ({selectedEmployee.empid})
      </span>
      <button
        onClick={clearSelection}
        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#d32f2f' }}
      >
        ✕
      </button>
    </div>
  )} */}
</div>

            <div className="mb-4">
              <label className="block text-sm  text-left font-semibold font-inter mb-1">
                Task Description
              </label>
              <textarea
                placeholder="Enter task description..."
                value={taskDescription}
              onChange={(e) => {
  setTaskDescription(e.target.value);
  setFormErrors((prevErrors) => {
    const { taskDescription, ...rest } = prevErrors;
    return rest;
  });
}}
                className={`w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#900] ${
                  formErrors.taskDescription ? 'border-red-500' : 'border-gray-300'
                }`}
                rows="4"
              />
              {/* {formErrors.taskDescription && (
                <p className="text-red-500 text-sm">{formErrors.taskDescription}</p>
              )} */}
            </div>
            <div className="flex justify-between w-full gap-2">
              <button
                onClick={handleConfirmPrint}
                className="flex gap-2 px-4 py-2 bg-[#900] text-white rounded-md hover:bg-[#700]"
              >
                <img src={printpdf} alt="" /> Print
              </button>
              <button
                onClick={handleCloseModal}
                className="px-4 py-2 bg-[#F4F4F5] text-gray-800 rounded-md hover:bg-gray-200"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportsFilters;